import { render, staticRenderFns } from "./TitleItem.vue?vue&type=template&id=356f784a&scoped=true&"
import script from "./TitleItem.vue?vue&type=script&lang=js&"
export * from "./TitleItem.vue?vue&type=script&lang=js&"
import style0 from "./TitleItem.vue?vue&type=style&index=0&id=356f784a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f784a",
  null
  
)

export default component.exports